import React, { useEffect, useState } from "react";
import Sidebar from "../../comman_page/Sidebar";
import { HeaderDashboard } from "../../comman_page/HeaderDashboard";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import { Footer } from "../../../../../public/containers/footer/Footer";
import { useLocation } from "react-router-dom";
import { SharedButton } from "../../../../../sharedComponents/Button";
import moment from "moment";
import { NewDateRange } from "../../../../../sharedComponents/NewDateRange";
import { DatePicker } from "antd"



export const DiscountTrDetailReport = () => {
    const location = useLocation();
    const [loader, setLoader] = useState(false);

    const [trData, setTrData] = useState([]);
    const [fullAm, setFullAm] = useState();

    const [originalData, setOriginalData] = useState([]);

    const { RangePicker } = DatePicker;

    const getReport = async (data) => {
        setLoader(true);
        let array = [];
        let full_amount = 0;
        if (data && data.length > 0) {
            (data ?? []).forEach(e => {
                let fnl = 0;

                fnl = parseFloat(e.finalSubTotal);
                full_amount += parseFloat(fnl);

                let after_discount = parseFloat(e.finalBaseAmount) - parseFloat(e.discount);
                array.push({
                    subtotal: parseFloat(fnl).toFixed(2),
                    datetime: moment.unix(e.create_dt).format('DD-MMM-YYYY'),
                    client: e.name + ' ' + e.lastname,
                    method: "Credit/Debit",
                    discount_code_name: e.discount_code_name,
                    item: e.item_name,
                    finalBaseAmount: "$ " + parseFloat(e.finalBaseAmount).toFixed(2),
                    discount: "- $ " + parseFloat(e.discount).toFixed(2),
                    after_discount: "$ " + parseFloat(after_discount).toFixed(2),
                    finalTax1: "$ " + parseFloat(e.finalTax1).toFixed(2),
                    finalTax2: "$ " + parseFloat(e.finalTax2).toFixed(2),
                    finalAdjustPrice: "$ " + parseFloat(e.finalAdjustPrice).toFixed(2),
                    amount: "$ " + parseFloat(fnl).toFixed(2) || 0,
                })
            });
            setTrData(array);
            setFullAm(parseFloat(full_amount).toFixed(2));
            setLoader(false);
        } else {
            setTrData([]);
        }
        setLoader(false);
    }



    useEffect(() => {
        if (location && location.state) {
            setOriginalData(location.state);
            getReport(location.state)
        }
    }, [location.state])


    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();

    const [selectedDate, setSelectedDate] = useState();
    const [dvalue, setDvalue] = useState();


    const filterByDate = () => {
        if (!startDate || !endDate) {
            getReport(originalData);
            return;
        }

        const filtered = originalData.filter((item) => {
            const itemDate = moment.unix(item.create_dt).startOf('day');
            return itemDate.isBetween(
                moment(startDate).startOf('day'),
                moment(endDate).endOf('day'),
                null,
                '[]' // include both dates
            );
        });

        getReport(filtered);
    };

    useEffect(() => {
        if (startDate && endDate) {
            filterByDate();
        }
    }, [startDate, endDate]);



    const handleDateChange = (value) => {
        setDvalue(value);
        if (value && value.length === 2) {
            const formattedStartDate = moment(value[0].$d).format("YYYY-MM-DD");
            const formattedEndDate = moment(value[1].$d).format("YYYY-MM-DD");
            setStartDate(formattedStartDate);
            setEndDate(formattedEndDate);
        } else {
            setStartDate(null);
            setEndDate(null);
        }
    };


    return (
        <>
            {loader && <div className='MainLoader'> <Spinner animation="border" role="status" className='Loader'> </Spinner> </div>}
            <div className="MainDashboard">
                <div className="MainLayout">
                    <Row>
                        <Sidebar />
                        <Col>
                            <div className="RightSide">
                                <div style={{ marginLeft: '8rem' }}>
                                    <HeaderDashboard />
                                </div>
                                <section className="addClient innerContent">
                                    <div className="AddClientContent" style={{ marginLeft: '8rem' }}>
                                        <Container>
                                            <h4 className="mb-4">Discount Code Transaction Detail Report</h4>
                                            <Row>
                                                <Col>
                                                    <div className="daterange_parent d-flex" style={{ justifyContent: 'space-between' }}>
                                                        <div className="daterange_parent">
                                                            <RangePicker
                                                                value={dvalue}
                                                                format="DD-MM-YYYY"
                                                                onChange={handleDateChange}
                                                            />
                                                        </div>
                                                        <SharedButton
                                                            title={"Reset"}
                                                            className={"backBtn"}
                                                            type={"button"}
                                                            onClick={() => {
                                                                setDvalue();
                                                                setStartDate(null);
                                                                setEndDate(null);
                                                                getReport(originalData);
                                                            }}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col className="text-right">
                                                    <SharedButton
                                                        title={"Back"}
                                                        className={"backBtn"}
                                                        type={"button"}
                                                        onClick={() => {
                                                            window.history.back();
                                                        }}
                                                    />
                                                </Col></Row>
                                            <Row className="mt-3">
                                                <Col md={12}>
                                                    <div className="row transactionReport w-100">
                                                        <div style={{ overflowX: 'auto', }}>
                                                            <table className="table table-striped table-bordered" style={{ whiteSpace: 'nowrap' }}>
                                                                <thead>
                                                                    <tr>
                                                                        <th>Date/Time</th>
                                                                        <th>Client Name</th>
                                                                        <th>Method</th>
                                                                        <th>DiscountCode</th>
                                                                        <th>Item</th>
                                                                        <th>Initial Cost</th>
                                                                        <th>Discount Amount</th>
                                                                        <th>Sub Total After Discount</th>
                                                                        <th>Tax 1</th>
                                                                        <th>Tax 2</th>
                                                                        <th>Total Fee Charged</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody style={{ fontSize: '14px' }}>
                                                                    {trData && trData.length > 0 && trData.map((row, index) => (
                                                                        <tr key={index}>
                                                                            <td>{row.datetime}</td>
                                                                            <td>{row.client}</td>
                                                                            <td>{row.method}</td>
                                                                            <td>{row.discount_code_name}</td>
                                                                            <td>{row.item}</td>
                                                                            <td>{row.finalBaseAmount}</td>
                                                                            <td>{row.discount}</td>
                                                                            <td>{row.after_discount}</td>
                                                                            <td>{row.finalTax1}</td>
                                                                            <td>{row.finalTax2}</td>
                                                                            <td>{row.amount}</td>
                                                                        </tr>
                                                                    ))}

                                                                    {trData && trData.length > 0 && (
                                                                        <tr className='highlighted highlighted-my'>
                                                                            <td>Total</td>
                                                                            <td colSpan="9"></td>
                                                                            <td colSpan="2" style={{ whiteSpace: 'nowrap' }}>$ {fullAm}</td>
                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                        {trData && trData.length <= 0 && (
                                                            <p className="text-center mt-4">No Data Available</p>
                                                        )}

                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </section>
                                <Footer />
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    );
};
